import React, { useContext, useEffect, useState } from 'react'
import { getRequest, postRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import MappingItem from './MappingItem'
import ReferenceSelector from './ReferenceSelector'
import { ConnectorViewMappingContext } from './context/context'
import { ProgresSpinner } from '../../common/ProgresSpinner'
import ConnectorSearchFilter from './ConnectorSearchFilter'
import { NavContext } from '../../../context/global_context'

const ConnectorMappingForm = (props) => {
  const [connVwMpState, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)

  const { connector_view, vehicle } = useParams()
  const [state, setState] = useState({
    activeTab: 'pending',
    referenceSelectorVisible: false,
    loader: false,
  })
  const [connectors, setConnectors] = useState([])
  const [pendingConnectors, setPendingConnectors] = useState([])
  const [mappedConnectors, setMappedConnectors] = useState([])

  useEffect(() => {
    getConnectorsData()
  }, [])

  const getConnectorsData = async (reference, connector, hide_sidebar) => {
    setState({ ...state, loader: true })
    let res = await getRequest(
      `/api/connector_views/connectors/${connector_view}/`
    )
    setConnectors(res.data)
    setState({ ...state, loader: false })
    setPendingConnectors(
      res.data?.length > 0 ? res.data?.filter((ctr) => !ctr.auto_mapped) : []
    )
    let tempMappedConnectors =
      res.data?.length > 0 ? res.data?.filter((ctr) => ctr.auto_mapped) : []
    setMappedConnectors(tempMappedConnectors)
    formatMappedReferences(
      tempMappedConnectors,
      reference,
      connector,
      hide_sidebar
    )
  }

  const formatMappedReferences = (data, reference, connector, hide_sidebar) => {
    let tempMappedReferences = {}
    data.map((row, index) => {
      if (row.auto_mapped in tempMappedReferences) {
        tempMappedReferences[row.auto_mapped].push(row.name)
      } else {
        tempMappedReferences[row.auto_mapped] = [row.name]
      }
    })
    if (reference) {
      dispatch({
        type: 'update_mapping_and_reference',
        data: {
          connector: hide_sidebar
            ? {}
            : {
                ...connector,
                auto_mapped: null,
              },
          svg_group_reference: null,
          selected_reference: null,
          connector_view: {
            ...connVwMpState.connector_view,
            references: reference,
          },
          mappedReferences: tempMappedReferences,
        },
      })
    } else {
      dispatch({ type: 'mappedReferences', data: tempMappedReferences })
    }
  }

  const toggleTabs = () => {
    const activeTab = state.activeTab === 'pending' ? 'autoMapped' : 'pending'
    setState({ ...state, activeTab })
  }

  const onSelectMapping = (connector) => {
    dispatch({
      type: 'select_mapping',
      data: {
        connector: connector,
        svg_group_reference: connector.svg_group_reference,
        selected_reference: connector.auto_mapped,
      },
    })
  }

  const updateMapping = async (connector, ref, hide_sidebar = true) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Saving Mapping ...`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await postRequest(
      `/api/connector_views/save_connector_view_mapping/${connector_view}/`,
      {
        name: connector.name,
        connector: connector.id,
        reference: ref,
        prev_reference: connector.auto_mapped,
      }
    )
    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Mapping updated successfully`,
        },
      })
      if (ref) {
        document.getElementById(`${ref}`).classList.add('mappedSvgElement')
      } else {
        document
          .getElementById(`${connector.auto_mapped}`)
          ?.classList?.remove('mappedSvgElement')
      }
      getConnectorsData(res.svg_group_reference, connector, hide_sidebar)
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    }
  }

  const { activeTab, referenceSelectorVisible } = state

  const unmappedRefs = connVwMpState?.connector_view?.group_ids?.filter(
    (ref) => !connectors.map((c) => c.reference).includes(ref)
  )

  let pendingLink, autoMappedLink, connectorsToRender

  const highLighted = 'font-bold text-white border-white'
  const faded = 'font-normal text-gray-600 border-gray-600'

  if (activeTab === 'pending') {
    autoMappedLink = faded
    pendingLink = highLighted
    connectorsToRender = pendingConnectors
  } else {
    autoMappedLink = highLighted
    pendingLink = faded
    connectorsToRender = mappedConnectors
  }

  const filterConnector = (name, category) => {
    if (name && category) {
      setPendingConnectors(
        connectors?.length > 0
          ? connectors?.filter(
              (ctr) =>
                !ctr.auto_mapped &&
                ctr.name.includes(name) &&
                ctr.category.includes(category)
            )
          : []
      )
    } else if (name) {
      setPendingConnectors(
        connectors?.length > 0
          ? connectors?.filter(
              (ctr) => !ctr.auto_mapped && ctr.name.includes(name)
            )
          : []
      )
    } else if (category) {
      setPendingConnectors(
        connectors?.length > 0
          ? connectors?.filter(
              (ctr) => !ctr.auto_mapped && ctr.category.includes(category)
            )
          : []
      )
    } else {
      setPendingConnectors(
        connectors?.length > 0
          ? connectors?.filter((ctr) => !ctr.auto_mapped)
          : []
      )
    }
  }

  return (
    <div className="w-1/5 items-stretch flex-grow flex flex-col text-black" style={{backgroundColor: '#212738'}}>
      {connVwMpState?.connector?.id ? (
        <ReferenceSelector
          connector={connVwMpState?.connector}
          unmappedReferences={unmappedRefs}
          onClick={(connector, ref, hide_sidebar) => {
            updateMapping(connector, ref, hide_sidebar)
          }}
          sid={vehicle}
          connectorViewId={connector_view}
        />
      ) : (
        <div
          className={`flex-grow flex-col flex items-stretch ${
            referenceSelectorVisible ? 'hidden' : ''
          }`}
        >
          <div className="w-full flex flex-row">
            <div
              onClick={toggleTabs}
              className={`border-b-2 p-4 w-1/2 text-center cursor-pointer ${pendingLink}`}
            >
              Pending({pendingConnectors.length})
            </div>
            <div
              onClick={toggleTabs}
              className={`border-b-2 p-4 w-1/2 text-center cursor-pointer ${autoMappedLink}`}
            >
              Mapped({mappedConnectors.length})
            </div>
          </div>

          <div className="mt-1 px-1 flex-auto h-0">
            <div className="w-full bg-tracer-lt-blue text-white font-normal rounded-t pl-1 flex justify-between items-center">
              <div>Select Connector</div>
              {state.activeTab === 'pending' && (
                <ConnectorSearchFilter
                  filterConnector={(category, name) => {
                    filterConnector(category, name)
                  }}
                />
              )}
            </div>
            <div className="overflow-auto" style={{ height: '80vh' }}>
              {connectorsToRender?.length < 1 ? (
                <div className="flex flex-col flex-grow items-center bg-white w-full px-2 py-3 border-b border-tracer-dark-blue cursor-pointer group hover:bg-blue-100">
                  {state?.loader ? (
                    <ProgresSpinner caption="Loading Connectors" />
                  ) : (
                    'Data not available'
                  )}
                </div>
              ) : (
                connectorsToRender.map((connector, idx) => (
                  <MappingItem
                    connector={connector}
                    key={idx}
                    onClick={() => onSelectMapping(connector)}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ConnectorMappingForm.propTypes = {}

export default ConnectorMappingForm
